"use client";

import { type PropsWithChildren, useEffect, useRef } from "react";
import { FaRegUser } from "react-icons/fa";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { MdOutlineListAlt, MdOutlinePeopleAlt } from "react-icons/md";

import { MigrationLink } from "@/common/components-2/migration-link";
import { env } from "@/common/env/client.mjs";

import { Hamburger } from "./hamburger.component";
import { MobileStickyMenuItem } from "./mobile-sticky-menu-item.component";

function LinkItem({ href, children }: PropsWithChildren<{ href: string }>) {
  return (
    <li className="block w-full">
      <MigrationLink href={href}>{children}</MigrationLink>
    </li>
  );
}

interface MobileStickyMenuWrapperProps {
  labels: {
    catalog: string;
    patients: string;
    cart: string;
    profile: string;
    menu: string;
  };
}

// TODO: Make navItems i18nable

export function MobileStickyMenuWrapper({ children, labels }: PropsWithChildren<MobileStickyMenuWrapperProps>) {
  const checkRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const onHashChange = () => {
      if (checkRef.current) {
        checkRef.current.checked = false;
      }
    };

    window.addEventListener("hashchange", onHashChange);

    return () => {
      const navElement = document.querySelector(".nav-menu-top");
      if (navElement) navElement.classList.remove("opened");

      window.removeEventListener("hashchange", onHashChange);
    };
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const navElement = document.querySelector(".nav-menu-top");

    if (navElement) {
      if (event.target.checked) {
        navElement.classList.add("opened");
      } else {
        navElement.classList.remove("opened");
      }
    }
  };

  return (
    <div className="z-30 max-lg:shadow-[0_-10px_32px_4px_rgba(0,90,217,0.12)] max-xl:fixed max-xl:bottom-0 max-xl:left-0 max-xl:w-full max-xl:bg-white">
      <ul className="max-xl:flex max-xl:justify-between">
        <LinkItem href="/katalog-badan">
          <MobileStickyMenuItem
            isHiddenOnDesktop
            icon={<MdOutlineListAlt className="text-2xl" />}
            title={labels.catalog}
            className="min-w-[105px]"
          />
        </LinkItem>
        <LinkItem href="/katalog-badan/pacjenci">
          <MobileStickyMenuItem
            isHiddenOnDesktop
            icon={<MdOutlinePeopleAlt className="text-2xl" />}
            title={labels.patients}
          />
        </LinkItem>
        <LinkItem href="/katalog-badan/koszyk">
          <MobileStickyMenuItem
            isHiddenOnDesktop
            icon={<HiOutlineShoppingBag className="text-2xl" />}
            title={labels.cart}
          />
        </LinkItem>
        <LinkItem
          href={`https://portal.${env.NEXT_PUBLIC_BASE_URL.replace("http://", "").replace("https://", "")}/panel`}
        >
          <MobileStickyMenuItem
            isHiddenOnDesktop
            icon={<FaRegUser className="mb-0.5 text-lg" />}
            title={labels.profile}
          />
        </LinkItem>
        <li className="block w-full">
          <MobileStickyMenuItem
            title={labels.menu}
            icon={
              <label className="relative z-40" htmlFor="mobile-menu">
                <input
                  ref={checkRef}
                  className="peer hidden"
                  type="checkbox"
                  id="mobile-menu"
                  onChange={handleChange}
                />
                <Hamburger />
                {children}
              </label>
            }
          />
        </li>
      </ul>
    </div>
  );
}
